var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8112d",
    d: "M22 0h10.7v40H22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e8112d",
    d: "M.7 14.7H54v10.6H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9dd16",
    d: "m9.8 23.9 2-2h17.5v-3.8H11.8l-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9dd16",
    d: "m23.4 2.5 2 2v17.4h3.9V4.4l2-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9dd16",
    d: "m31.2 37.5-2-2V18.2h-3.8v17.5l-2 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f9dd16",
    d: "m44.8 16.1-2 2H25.5v3.8H43l2 2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGg);
export default __webpack_public_path__ + "static/media/gg.3bf4cf73a447282d2cc3e39c25c600c1.svg";
export { ForwardRef as ReactComponent };